<template>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
    <div class="space-y-1">
      <span class="block text-sm font-medium leading-6 text-surface-700">Marchés</span>
      <MultiSelect
        v-model="marketIdsModel" :options="marketOptions" option-label="name" option-value="value" filter
        display="chip" placeholder="Sélectionner des marchés" class="w-full text-sm" :max-selected-labels="500" show-clear
        panel-class="text-sm" :disabled="!showMarketFilter" :pt="{
          root: { class: 'flex-wrap items-start py-2 px-3' },
          label: { class: 'text-sm' },
          item: { class: 'py-2 px-3 text-sm' },
          header: { class: 'py-2 px-3 text-sm' },
          filterInput: { class: 'text-sm py-1' },
          token: { class: 'text-sm px-2 py-1 m-1 rounded bg-primary-100 text-primary-800' },
          trigger: { class: 'px-2' }
        }" />
      <small v-if="!showMarketFilter" class="text-surface-500 text-xs">
        Sélectionnez une ville spécifique pour filtrer par marché.
      </small>
    </div>

    <div class="space-y-1">
      <span class="block text-sm font-medium leading-6 text-surface-700">Type de documents</span>
      <MultiSelect
        v-model="mediaTypeIdsModel" :options="documentTypeOptions" option-label="name" option-value="value"
        filter display="chip" placeholder="Sélectionner un ou plusieurs types de documents" class="w-full text-sm"
        :max-selected-labels="500" show-clear panel-class="text-sm" :loading="isLoading" :pt="{
          root: { class: 'flex-wrap items-start py-2 px-3' },
          label: { class: 'text-sm' },
          item: { class: 'py-2 px-3 text-sm' },
          header: { class: 'py-2 px-3 text-sm' },
          filterInput: { class: 'text-sm py-1' },
          token: { class: 'text-sm px-2 py-1 m-1 rounded bg-primary-100 text-primary-800' },
          trigger: { class: 'px-2' }
        }" />
    </div>

    <div class="space-y-1">
      <span class="block text-sm font-medium leading-6 text-surface-700">Généré par</span>
      <Select
        v-model="createdByUserIdModel" :options="generatedByOptions" show-clear option-label="name"
        option-value="value" placeholder="-- Sélectionner un utilisateur --" class="w-full" :loading="isLoading" />
    </div>

    <div class="space-y-1">
      <span class="block text-sm font-medium leading-6 text-surface-700">Commerçant</span>
      <small v-if="selectedCity == null" class="text-surface-500 text-xs">
        Sélectionnez une ville spécifique pour filtrer par commerçants.
      </small>
      <Select
        v-model="merchantIdModel" :options="merchantOptions" show-clear option-label="name" option-value="value"
        placeholder="-- Sélectionner un commerçant --" class="w-full" :loading="isLoadingMerchants"
        :disabled="selectedCity == null" />
    </div>
  </div>
</template>

<script setup lang="ts">
import MultiSelect from "primevue/multiselect";
import Select from "primevue/select";

import type { DocumentStateOption } from "~/types/ReportingDocumentStateExport";

defineProps<{
  documentTypeOptions: DocumentStateOption[];
  generatedByOptions: DocumentStateOption[];
  merchantOptions: DocumentStateOption[];
  marketOptions: DocumentStateOption[];
  showMarketFilter: boolean;
  isLoading: boolean;
  isLoadingMerchants: boolean;
  selectedCity: number | null;
}>();

const mediaTypeIdsModel = defineModel<number[]>("mediaTypeIds", {
  required: true,
});
const createdByUserIdModel = defineModel<number | null>("createdByUserId", {
  required: true,
});
const merchantIdModel = defineModel<number | null>("merchantId", {
  required: true,
});
const marketIdsModel = defineModel<number[]>("marketIds", {
  required: true,
});
</script>
